import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AdalService } from 'adal-angular4';
import { Observable } from 'rxjs';
import { CommonService } from './Common.service';
import { EncryptDecryptService } from './encrypt-decrypt.service';
import { RestApiService } from './rest-api.service';

@Injectable({
  providedIn: 'root'
})
export class FinaDrawingReportService {

  private readonly GetFinalDrawingList = 'Dashboard/GetFinalDrawingList';

  
  constructor(public router: Router, private adal: AdalService, public restApiService: RestApiService, public commonService: CommonService, private _encryptDecryptService:EncryptDecryptService) { }


  getFinalDrawingList(obj:any): Observable<any>{   
    return this.restApiService.new_POST(this.GetFinalDrawingList, obj);
  }


}
